export function diffArrays(a, b) {
    return a.filter((c) => !b.some((d) => d === c));
}
export function unionArrays(a, b) {
    return a.filter((c) => b.some((d) => d === c));
}
//# sourceMappingURL=arrays.js.map